import { ref, computed } from "vue";
import { useStore } from "vuex";
import { columns, options } from "@/helpers/kpiTableHelper";

export default function useKpiTable() {
  const store = useStore();

  const selected_rows = ref([]);
  const tableData = computed(() => store.getters["kpis/getReport"]);

  const tableOptions = {
    ...options,
  };

  const onSelect = ({ dt, type }) => {
    if (type === "row") {
      selected_rows.value = dt.rows({ selected: true }).data().toArray();
    }
  };

  const onDeselect = ({ dt, type }) => {
    if (type === "row") {
      selected_rows.value = dt.rows({ selected: true }).data().toArray();
    }
  };

  return {
    columns,
    tableData,
    tableOptions,
    onSelect,
    onDeselect,
  };
}
